// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"25ef5df4","787":"ec347a6f","911":"b3fb10f0"}[chunkId] + ".chunk.js";
};